export const PROGRAM_STATUS_COLORS = {
  accepted: 'green',
  pending: 'orange',
  rejected: 'red',
  on_hold: 'volcano',
  suspended: 'default',
  not_signed_up: 'default',
  signed_out: 'default',
  not_joined_unknown: 'default',
}

export const isKarmaEarnNetwork = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '') === 'karmaearn'

export const PROGRAM_STATUS_OPTIONS = [
  { label: 'Not Signed Up', value: 'not_signed_up' },
  { label: 'Pending', value: 'pending' },
  { label: 'Accepted', value: 'accepted' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'On Hold', value: 'on_hold' },
  { label: 'Suspended', value: 'suspended' },
  { label: 'Signed Out', value: 'signed_out' },
  { label: 'Not Joined Unknown', value: 'not_joined_unknown' },
]

export const DOMAIN_TYPE_OPTIONS = [
  { label: 'Game', value: 'GAME' },
  { label: 'App', value: 'APP' },
]

export const GOAL_TYPE_OPTIONS = [
  { label: 'Unknown', value: 'UNKNOWN' },
  { label: 'Install', value: 'INSTALL' },
  { label: 'Milestone', value: 'MILESTONE' },
  { label: 'In-App Purchase', value: 'IN_APP_PURCHASE' },
  { label: 'Time Played', value: 'TIME_PLAYED' },
  { label: 'Bonus', value: 'BONUS' },
  { label: 'In-App Advertising', value: 'IN_APP_ADVERTISING' },
]

export const GOAL_STATUS_OPTIONS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Suspended', value: 'SUSPENDED' },
  { label: 'Adhoc', value: 'ADHOC' },
]

export const GOAL_COMPLIANCE_METRIC_OPTIONS = [
  { label: 'Unknown', value: 'UNKNOWN' },
  { label: 'Time (minutes)', value: 'TIME_MINUTES' },
  { label: 'Level', value: 'LEVEL' },
  { label: 'Purchase Count', value: 'PURCHASE_COUNT' },
  { label: 'Purchase Amount (cents)', value: 'PURCHASE_AMOUNT_CENTS' },
  { label: 'Deposit Amount (cents)', value: 'DEPOSIT_AMOUNT_CENTS' },
  { label: 'Streak Days', value: 'STREAK_DAYS' },
  { label: 'Action Count', value: 'ACTION_COUNT' },
]
